// @flow

import React from 'react';

import _ from 'lodash';

import { ADMIN_APP_ASSET_PATHS } from 'src/constants/assets';
import { getAssetURL } from 'src/helpers';

import YotpoCard from 'src/components/containers/tools/integration/yotpo-card';
import StampedioCard from 'src/components/containers/tools/integration/stampedio-card';
// import AliCard from 'src/components/containers/tools/integration/ali-card';
import ReviewCard from 'src/components/containers/tools/integration/review-card';
import GemPagesCard from 'src/components/containers/tools/integration/gempages-card';

import KlaviyoCard from 'src/components/containers/tools/integration/klaviyo-card';
import ReviewsIoCard from 'src/components/containers/tools/integration/reviews-io-card';
import AttentiveCard from 'src/components/containers/tools/integration/attentive-card';

// import IntegrationCard from 'src/components/containers/tools/integration/integration-card';
import AliCard from 'src/components/containers/tools/integration/ali-card';
import { getShop } from 'src/helpers';
import ProductLabelsCard from 'src/components/containers/tools/integration/product-label-card';
import IntegrationWishlistCard from 'src/components/containers/tools/integration/integration-wishlist-card';
import GlobalSellingCard from 'src/components/containers/tools/integration/global-selling-card';
import OtherCard from 'src/components/containers/tools/integration/integration-other-card';
import SupportCRMCard from 'src/components/containers/tools/integration/support-crm-card';
import AnalyticsCard from 'src/components/containers/tools/integration/analytics-card';

export const AppType = {
  reviews: 'reviews',
  currencies: 'currencies',
  languages: 'languages',
  others: 'others',
  labels: 'labels',
  wishlists: 'wishlists',
  smsEmail: 'emailSMS',
  featuringPartner: 'featuringPartner',
  pageBuilder: 'pageBuilder',
  globalSelling: 'globalSelling',
  supportCRM: "supportCRM",
  analytics: 'analytics'
};

export const AppName = {
  YOTPO: 'yotpo',
  STAMPED: 'stamped',
  ALI: 'aliReview',
  JUDGEME: 'judgeme',
  RIVYO: 'rivyo',
  RYVIU: 'ryviu',
  PRS: 'prs',
  LOOX: 'loox',
  LAI_ALI_EXPRESS: 'LAIAliExpress',
  OKENDO: 'okendo',
  SHOPNEY: 'shopney',
  VAJRO: 'vajro',
  GEMPAGES: 'gemPages',
  ALI_REVIEW: 'aliReview',

  REVIEWSIO: 'ReviewsIO',
  KLAVIYO: 'klaviyo',
  GEM_PAGES: 'gemPages',
  DECO: 'deco',
  FLAIR: 'flair',
  WISHLIST_KING: 'king',
  WISHLIST_PLUS: 'plus',
  WISHLIST_SMART: 'smart',
  WISHLIST_IWISHLIST: 'i-wishlist',
  REVIEWS_LOYALTY_WISHLIST: 'reviewsLoyaltyWishlist',
  BEST: 'best',
  AUTO: 'auto',
  GROWE: 'growave',
  SHOPIFY_TRANSLATE_ADAPT: 'shopify-translate-adapt',
  LANGIFY: 'langify',
  LANGSHOP: 'langshop',
  WEGLOT: 'weglot',
  MULTI_CURRENCY: 'multi-currency',
  ATTENTIVE: 'attentive',
  GLOBAL_E: 'globalE',
  GORGIAS: 'gorgias',
  SHOPIFY_COMBINED_LISTINGS: 'shopifyCombinedListings',
  GOOGLE_ANALYTICS_4: 'google-analytics-4',
  TRANSCY: 'transcy',
}

export const AppTypeOnlyAutoOnV3 = ['currencies', 'languages', 'others', 'labels', 'wishlists'];

export const KLAVIYO_REVIEW_APP_NAME = 'klaviyoReview';

export const AppNameShow = {
  yotpo: 'Yotpo Product Reviews & UGC',
  stamped: 'Stamped Product Reviews & UGC',
  aliReview: 'Ali Reviews ‑ Product Reviews',
  judgeme: 'Judge.me Product Reviews',
  rivyo: 'Rivyo Product Reviews & QA',
  reviewsLoyaltyWishlist: 'Growave: Loyalty & Wishlist',
  ryviu: 'Ryviu: Product Reviews & QA',
  prs: 'Product Reviews',
  loox: 'Loox Product Reviews & Photos',
  LAIAliExpress: 'LAI Ali Reviews Product Review',
  ReviewsIO: 'REVIEWS.IO Product Reviews',
  best: 'BEST Currency Converter',
  auto: 'Auto Currency Switcher',
  okendo: 'Okendo: Product Reviews & UGC',
  flair: 'Flair Product Badges + Labels',
  deco: 'DECO Product Labels & Badges',
  [KLAVIYO_REVIEW_APP_NAME]: 'Klaviyo Reviews',
  plus: 'Swym Wishlist Plus',
  smart: 'Smart Wishlist',
  'i-wishlist': 'Mst (formerly iWish): Wishlist',
  'global-e': 'Global-e: Global Selling',
  gorgias: "Gorgias: Helpdesk & Live Chat",
  shopifyCombinedListings: "Shopify Combined Listings",
  'google-analytics-4': 'Google Analytics 4',
  transcy: 'Transcy: AI Language Translate',
};

export const aliReviewSupport = [
  'ultamodan.myshopify.com',
  'eidonsurfswim.myshopify.com',
  'skyeswim.myshopify.com',
  'bestvalue-resume.myshopify.com',
  'ruff-houzin.myshopify.com',
  'ultamodan-au.myshopify.com',
  'ultamodan-us.myshopify.com',
  'selesta-sake.myshopify.com',
  'nogibjj.myshopify.com',
  'factory21-id.myshopify.com',
  'vip-luggage2021.myshopify.com',
  'vip-lhb2021.myshopify.com',
  'prado-rugs.myshopify.com',
  'marie-dubie.myshopify.com',
  'uopochi.myshopify.com',
  'neon-shisha.myshopify.com',
  'sake-ya-online-demo.myshopify.com',
  'little-holmes.myshopify.com',
  'glamberryboutique.myshopify.com',
  'yossrafitness4.myshopify.com',
  'ayopa-indonesia.myshopify.com',
  'crocsvietnam.myshopify.com',
  'supporto-cuffie.myshopify.com',
  'maison-galile.myshopify.com',
  'tejjen1.myshopify.com',
  'slo-tech.myshopify.com',
  'allouttech.myshopify.com',
  'hair-store-3902.myshopify.com',
  'affiliate-test123.myshopify.com',
  'bigmercadao.myshopify.com',
  'dslshop.myshopify.com',
  'sweat-plaid-6093.myshopify.com',
  'customstore12569.myshopify.com',
  'getme-fit.myshopify.com',
  'psychedelic-rhapsody.myshopify.com',
  'softwarecw.myshopify.com',
  'francis-m-doe-vip-clothing.myshopify.com',
  'lapink-5041.myshopify.com',
  'a5c772-2.myshopify.com',
  'bbbf34-2.myshopify.com',
  'bruteimpact.myshopify.com',
  'lemonade935681.myshopify.com',
  'e39dec.myshopify.com',
  'flip-mobile-martinique.myshopify.com',
  'totse420.myshopify.com',
  'socialhead-store-real.myshopify.com',
  'zdesign-inc.myshopify.com',
  'immortalgroup.myshopify.com',
  'sunielle.myshopify.com',
  '54b0db.myshopify.com',
  '642548-2.myshopify.com',
  '55d6c2.myshopify.com',
  'f3c072.myshopify.com',
  'd68956-3.myshopify.com',
  'bc-dev-v2-bonnie-07.myshopify.com',
  'bc-dev-v2-helen4.myshopify.com'
];

export let MULTI_LANGUAGE = [
  {
    name: 'AdminHTML.Integration.Constants.multipleLanguage_ShopifyTranslate_Name',
    icon: getAssetURL(ADMIN_APP_ASSET_PATHS?.integration?.shopifyMultiCurrency),
    description: 'AdminHTML.Integration.Constants.multipleLanguage_ShopifyTranslate_Description',
    appListingURL: 'https://apps.shopify.com/translate-and-adapt',
    instructionURL:
      'https://support.boostcommerce.net/en/articles/9359387-shopify-translate-adapt-language-integration-guide',
    integration: 'AdminHTML.Integration.Constants.autoIntegration',
    appName: AppName.SHOPIFY_TRANSLATE_ADAPT,
    appType: AppType.languages,
    position: 3
  },
  {
    name: 'AdminHTML.Integration.Constants.multipleLanguage_WeglotTranslate_Name',
    icon: getAssetURL(ADMIN_APP_ASSET_PATHS?.integration?.weglotTranslate),
    description: 'AdminHTML.Integration.Constants.multipleLanguage_WeglotTranslate_Description',
    appListingURL: 'https://apps.shopify.com/weglot',
    instructionURL:
      'https://support.boostcommerce.net/en/articles/9356306-weglot-integration-guide',
    integration: 'AdminHTML.Integration.Constants.manualIntegration',
    appName: AppName.WEGLOT,
    isManually: true,
    appType: AppType.languages,
    position: 4
  },
  {
    name: 'AdminHTML.Integration.Constants.multipleLanguage_Langify_Name',
    icon: getAssetURL(ADMIN_APP_ASSET_PATHS?.integration?.langify),
    description: 'AdminHTML.Integration.Constants.multipleLanguage_Langify_Description',
    appListingURL: 'https://langify-app.com/discount/boostcommerce',
    instructionURL:
      'https://support.boostcommerce.net/en/articles/9360156-langify-integration-guide',
    integration: 'AdminHTML.Integration.Constants.manualIntegration',
    appName: AppName.LANGIFY,
    isManually: true,
    appType: AppType.languages,
    position: 1
  },
  {
    name: 'AdminHTML.Integration.Constants.multipleLanguage_LangShop_Name',
    icon: getAssetURL(ADMIN_APP_ASSET_PATHS?.integration?.langshop),
    description: 'AdminHTML.Integration.Constants.multipleLanguage_LangShop_Description',
    appListingURL: 'https://apps.shopify.com/langshop',
    instructionURL:
      'https://support.boostcommerce.net/en/articles/9356370-langshop-integration-guide',
    integration: 'AdminHTML.Integration.Constants.manualIntegration',
    appName: AppName.LANGSHOP,
    isManually: true,
    appType: AppType.languages,
    position: 7
  },
  {
    name: 'AdminHTML.Integration.Constants.multipleLanguage_Transcy_Name',
    icon: getAssetURL(ADMIN_APP_ASSET_PATHS?.integration?.transcyTranslate),
    description: 'AdminHTML.Integration.Constants.multipleLanguage_Transcy_Description',
    appListingURL: 'https://apps.shopify.com/transcy',
    instructionURL: '#', // TODO: replace with real integration guide URL once available
    integration: 'AdminHTML.Integration.Constants.manualIntegration',
    appName: AppName.TRANSCY,
    isManually: true,
    appType: AppType.languages,
    position: 8
  }
];

export let MULTI_CURRENCY = [
  {
    name: 'AdminHTML.Integration.Constants.multiCurrency_ShopifyMultiCurrency_Name',
    icon: getAssetURL(ADMIN_APP_ASSET_PATHS?.integration?.shopifyMultiCurrency),
    description: 'AdminHTML.Integration.Constants.multiCurrency_ShopifyMultiCurrency_Description',
    appListingURL: 'https://help.shopify.com/en/manual/payments/multi-currency',
    instructionURL:
      'https://support.boostcommerce.net/en/articles/9359978-shopify-multi-currency-integration-guide',
    integration: 'AdminHTML.Integration.Constants.autoIntegration',
    appName: AppName.MULTI_CURRENCY,
    appType: AppType.currencies,
    position: 2
  },
  {
    name: 'AdminHTML.Integration.Constants.multiCurrency_BestCurrencyConverter_Name',
    icon: getAssetURL(ADMIN_APP_ASSET_PATHS?.integration?.bestCurrencyConverter),
    description: 'AdminHTML.Integration.Constants.multiCurrency_BestCurrencyConverter_Description',
    appListingURL: 'https://apps.shopify.com/doubly-currency-converter',
    instructionURL:
      'https://support.boostcommerce.net/en/articles/9460511-best-currency-converter-integration-guide',
    integration: 'AdminHTML.Integration.Constants.autoIntegration',
    appType: AppType.currencies,
    appName: AppName.BEST,
    position: 11
    // render: (index, data) => {
    //   return <IntegrationCard index={index} data={data} />;
    // }
  },
  {
    name: 'AdminHTML.Integration.Constants.multiCurrency_Auto_Currency_Switcher',
    icon: getAssetURL(ADMIN_APP_ASSET_PATHS?.integration?.mlvAutoCurrencySwitcher),
    description: 'AdminHTML.Integration.Constants.multiCurrency_Auto_Currency_Switcher_Description',
    appListingURL: 'https://apps.shopify.com/auto-currency-switcher',
    instructionURL:
      'https://support.boostcommerce.net/en/articles/9359997-auto-currency-switcher-integration-guide',
    integration: 'AdminHTML.Integration.Constants.autoIntegration',
    appType: AppType.currencies,
    appName: AppName.AUTO,
    position: 10
    // render: (index, data) => {
    //   return <IntegrationCard index={index} data={data} />;
    // }
  }
];

export let WISHLIST = [
  {
    name: 'AdminHTML.Integration.Constants.wishlist_WishlistPlus_Name',
    integration: 'AdminHTML.Integration.Constants.autoIntegration',
    icon: getAssetURL(ADMIN_APP_ASSET_PATHS?.integration?.wishlistPlus),
    description: 'AdminHTML.Integration.Constants.wishlist_WishlistPlus_Description',
    appListingURL: 'https://apps.shopify.com/swym-relay',
    instructionURL:
      'https://support.boostcommerce.net/en/articles/9360695-wishlist-plus-integration-guide',
    // integration: 'AdminHTML.Integration.Constants.autoIntegration',
    appType: AppType.wishlists,
    appName: AppName.WISHLIST_PLUS,
    position: 6,
    autoIntegration: true,
    render: (index, data) => {
      return <IntegrationWishlistCard index={index} data={data} />;
    }
  },
  {
    name: 'AdminHTML.Integration.Constants.wishlist_SmartWishlist_Name',
    integration: 'AdminHTML.Integration.Constants.autoIntegration',
    icon: getAssetURL(ADMIN_APP_ASSET_PATHS?.integration?.smartWishlist),
    description: 'AdminHTML.Integration.Constants.wishlist_SmartWishlist_Description',
    appListingURL: 'https://apps.shopify.com/smart-wishlist',
    instructionURL:
      'https://support.boostcommerce.net/en/articles/9360679-smart-wishlist-integration-guide',
    // integration: 'AdminHTML.Integration.Constants.autoIntegration',
    appType: AppType.wishlists,
    appName: AppName.WISHLIST_SMART,
    position: 26,
    autoIntegration: true,
    render: (index, data) => {
      return <IntegrationWishlistCard index={index} data={data} />;
    }
  },
  {
    name: 'AdminHTML.Integration.Constants.wishlist_ReviewsLoyaltyWishlist_Name',
    integration: 'AdminHTML.Integration.Constants.autoIntegration',
    icon: getAssetURL(ADMIN_APP_ASSET_PATHS?.integration?.reviewsLoyaltyWishlist),
    description: 'AdminHTML.Integration.Constants.wishlist_ReviewsLoyaltyWishlist_Description',
    appListingURL: 'https://growave.io/?discount_code=60days4boostcommerce',
    instructionURL:
      'https://support.boostcommerce.net/en/articles/9464378-growave-wishlist-integration-guide',
    // integration: 'AdminHTML.Integration.Constants.autoIntegration',
    appType: AppType.wishlists,
    appName: AppName.GROWE,
    position: 27
    // render: (index, data) => {
    //   return <IntegrationCard index={index} data={data} />;
    // }
  },
  {
    name: 'AdminHTML.Integration.Constants.wishlist_WishlistKing_Name',
    integration: 'AdminHTML.Integration.Constants.autoIntegration',
    icon: getAssetURL(ADMIN_APP_ASSET_PATHS?.integration?.wishlistKing),
    description: 'AdminHTML.Integration.Constants.wishlist_WishlistKing_Description',
    appListingURL: 'https://apps.shopify.com/wishlist-king',
    instructionURL:
      'https://support.boostcommerce.net/en/articles/9360729-wishlist-king-integration-guide',
    // integration: 'AdminHTML.Integration.Constants.autoIntegration',
    appType: AppType.wishlists,
    appName: AppName.WISHLIST_KING,
    position: 5
    // render: (index, data) => {
    //   return <IntegrationCard index={index} data={data} />;
    // }
  },
  {
    name: 'AdminHTML.Integration.Constants.wishlist_IWishlist_Name',
    icon: getAssetURL(ADMIN_APP_ASSET_PATHS?.integration?.iWishlist),
    description: 'AdminHTML.Integration.Constants.wishlist_IWishlist_Description',
    appListingURL: 'https://apps.shopify.com/i-wishlist',
    instructionURL:
      'https://support.boostcommerce.net/en/articles/9360685-iwishlist-integration-guide',
    // integration: 'AdminHTML.Integration.Constants.autoIntegration',
    appType: AppType.wishlists,
    appName: AppName.WISHLIST_IWISHLIST,
    position: 16,
    autoIntegration: true,
    render: (index, data) => {
      return <IntegrationWishlistCard index={index} data={data} />;
    }
  }
  // {
  //   name: 'AdminHTML.Integration.Constants.wishlist_WishlistShare_Name',
  //   icon: WishListShare,
  //   description: 'AdminHTML.Integration.Constants.wishlist_wishlistShare_Description',
  //   appListingURL: 'https://apps.shopify.com/wishlist-1',
  //   instructionURL: 'https://support.boostcommerce.net/en/articles/9359354-listr-wishlist-reminder-integration-guide',
  //   // integration: 'AdminHTML.Integration.Constants.autoIntegration',
  //   // appType: AppType.wishlists,
  //   appName: 'wishlist-1',
  //   // render: (index, data) => {
  //   //   return <IntegrationCard index={index} data={data} />;
  //   // }
  // }
];

export let PRODUCT_LABELS = [
  {
    name: 'AdminHTML.Integration.Constants.productLabel_FlairProductBadgesLabels_Name',
    integration: 'AdminHTML.Integration.Constants.autoIntegration',
    icon: getAssetURL(ADMIN_APP_ASSET_PATHS?.integration?.flairProductBadgesLabels),
    description:
      'AdminHTML.Integration.Constants.productLabel_FlairProductBadgesLabels_Description',
    appListingURL: 'https://apps.shopify.com/flair',
    instructionURL:
      'https://support.boostcommerce.net/en/articles/9360721-flair-product-badges-banners-integration-guide',
    appType: AppType.labels,
    appName: AppName.FLAIR,
    autoIntegration: true,
    render: (index, data) => {
      return <ProductLabelsCard index={index} data={data} />;
    },
    position: 13
  },
  {
    name: 'AdminHTML.Integration.Constants.productLabel_ProductLabels_Name',
    integration: 'AdminHTML.Integration.Constants.manualIntegration',
    icon: getAssetURL(ADMIN_APP_ASSET_PATHS?.integration?.productLabels),
    description: 'AdminHTML.Integration.Constants.productLabel_ProductLabels_Description',
    appListingURL: 'https://apps.shopify.com/product-labels',
    instructionURL:
      'https://support.boostcommerce.net/en/articles/9360731-deco-product-labels-badges',
    appType: AppType.labels,
    appName: AppName.DECO,
    autoIntegration: false,
    render: (index, data) => {
      return <ProductLabelsCard index={index} data={data} />;
    },
    position: 12
  }
];

export const PRODUCT_SWATCHES = [[]];

export let PRODUCT_REVIEWS = [
  {
    name: 'AdminHTML.Integration.Constants.productReview_ReviewsIO_Name',
    integration: 'AdminHTML.Integration.Constants.autoIntegration',
    icon: getAssetURL(ADMIN_APP_ASSET_PATHS?.integration?.reviewsIo),
    smallIcon: getAssetURL(ADMIN_APP_ASSET_PATHS?.integration?.small?.reviewsIo),
    description: 'AdminHTML.Integration.Constants.productReview_ReviewsIO_Description',
    appListingURL: 'https://apps.shopify.com/reviews-co-uk-product-and-merchant-review-collection',
    instructionURL:
      'https://support.boostcommerce.net/en/articles/9570801-reviews-io-integration-guide',
    appType: AppType.reviews,
    appName: AppName.REVIEWSIO,
    isFeaturingPartner: true,
    render: (index, data) => {
      return <ReviewsIoCard index={index} data={data} />;
    }
  },
  {
    name: 'AdminHTML.Integration.Constants.productReview_YotpoReviews_Name',
    integration: 'AdminHTML.Integration.Constants.autoIntegration',
    icon: getAssetURL(ADMIN_APP_ASSET_PATHS?.integration?.yotpoReviews),
    smallIcon: getAssetURL(ADMIN_APP_ASSET_PATHS?.integration?.small?.yotpoReviews),
    description: 'AdminHTML.Integration.Constants.productReview_YotpoReviews_Description',
    appListingURL:
      'https://apps.shopify.com/yotpo-social-reviews?utm_source=co_marketing&utm_medium=Boostapp&utm_campaign=boost_app_admin',
    instructionURL: 'https://support.boostcommerce.net/en/articles/9360376-yotpo-integration-guide',
    appType: AppType.reviews,
    appName: AppName.YOTPO,
    render: (index, data) => {
      return <YotpoCard index={index} data={data} />;
    },
    position: 29
  },
  {
    name: 'AdminHTML.Integration.Constants.productReview_StampedReviews_Name',
    integration: 'AdminHTML.Integration.Constants.autoIntegration',
    icon: getAssetURL(ADMIN_APP_ASSET_PATHS?.integration?.stampedReviews),
    smallIcon: getAssetURL(ADMIN_APP_ASSET_PATHS?.integration?.small?.stampedReviews),
    description: 'AdminHTML.Integration.Constants.productReview_StampedReviews_Description',
    appListingURL: 'https://apps.shopify.com/product-reviews-addon',
    instructionURL:
      'https://support.boostcommerce.net/en/articles/9360404-stamped-io-integration-guide',
    appType: AppType.reviews,
    appName: AppName.STAMPED,
    render: (index, data) => {
      return <StampedioCard index={index} data={data} />;
    },
    position: 27
  },
  {
    name: 'AdminHTML.Integration.Constants.productReview_JudgemeProductReviews_Name',
    integration: 'AdminHTML.Integration.Constants.autoIntegration',
    icon: getAssetURL(ADMIN_APP_ASSET_PATHS?.integration?.judgemeProductReviews),
    smallIcon: getAssetURL(ADMIN_APP_ASSET_PATHS?.integration?.small?.judgemeProductReviews),
    description: 'AdminHTML.Integration.Constants.productReview_JudgemeProductReviews_Description',
    appListingURL: 'https://judge.me/free-trial/boostcommerce',
    instructionURL:
      'https://support.boostcommerce.net/en/articles/9355798-judge-me-integration-guide',
    appType: AppType.reviews,
    appName: AppName.JUDGEME,
    render: (index, data) => {
      return <ReviewCard index={index} data={data} />;
    },
    position: 17
  },
  {
    name: 'AdminHTML.Integration.Constants.productReview_RivyoProductReview_Name',
    integration: 'AdminHTML.Integration.Constants.autoIntegration',
    icon: getAssetURL(ADMIN_APP_ASSET_PATHS?.integration?.rivyoProductReview),
    smallIcon: getAssetURL(ADMIN_APP_ASSET_PATHS?.integration?.small?.rivyoProductReview),
    description: 'AdminHTML.Integration.Constants.productReview_RivyoProductReview_Description',
    appListingURL: 'https://apps.shopify.com/rivyo-product-review',
    instructionURL: 'https://support.boostcommerce.net/en/articles/9360199-rivyo-integration-guide',
    appType: AppType.reviews,
    appName: AppName.RIVYO,
    render: (index, data) => {
      return <ReviewCard index={index} data={data} />;
    },
    position: 23
  },
  {
    name: 'AdminHTML.Integration.Constants.productReview_ReviewsLoyaltyWishlist_Name',
    integration: 'AdminHTML.Integration.Constants.autoIntegration',
    icon: getAssetURL(ADMIN_APP_ASSET_PATHS?.integration?.reviewsLoyaltyWishlist),
    smallIcon: getAssetURL(ADMIN_APP_ASSET_PATHS?.integration?.small?.reviewsLoyaltyWishlist),
    description: 'AdminHTML.Integration.Constants.productReview_ReviewsLoyaltyWishlist_Description',
    appListingURL: 'https://growave.io/?discount_code=60days4boostcommerce',
    instructionURL:
      'https://support.boostcommerce.net/en/articles/9360361-growave-product-review-integration-guide',
    appType: AppType.reviews,
    appName: AppName.REVIEWS_LOYALTY_WISHLIST,
    render: (index, data) => {
      return <ReviewCard index={index} data={data} />;
    },
    position: 22
  },
  {
    name: 'AdminHTML.Integration.Constants.productReview_Ryviu_Name',
    integration: 'AdminHTML.Integration.Constants.autoIntegration',
    icon: getAssetURL(ADMIN_APP_ASSET_PATHS?.integration?.ryviu),
    smallIcon: getAssetURL(ADMIN_APP_ASSET_PATHS?.integration?.small?.ryviu),
    description: 'AdminHTML.Integration.Constants.productReview_Ryviu_Description',
    appListingURL: 'https://www.ryviu.com/',
    instructionURL: 'https://support.boostcommerce.net/en/articles/9360207-ryviu-integration-guide',
    appType: AppType.reviews,
    appName: AppName.RYVIU,
    render: (index, data) => {
      return <ReviewCard index={index} data={data} />;
    },
    position: 24
  },
  {
    name: 'AdminHTML.Integration.Constants.productReview_ProductReviewsShopify_Name',
    integration: 'AdminHTML.Integration.Constants.autoIntegration',
    icon: getAssetURL(ADMIN_APP_ASSET_PATHS?.integration?.productReviewsShopify),
    smallIcon: getAssetURL(ADMIN_APP_ASSET_PATHS?.integration?.small?.productReviewsShopify),
    description: 'AdminHTML.Integration.Constants.productReview_ProductReviewsShopify_Description',
    appListingURL: 'https://apps.shopify.com/product-reviews',
    instructionURL:
      'https://support.boostcommerce.net/en/articles/9359384-shopify-product-reviews-integration-guide',
    appType: AppType.reviews,
    appName: AppName.PRS,
    render: (index, data) => {
      return <ReviewCard index={index} data={data} />;
    },
    position: 21
  },
  {
    name: 'AdminHTML.Integration.Constants.productReview_LooxReviews_Name',
    integration: 'AdminHTML.Integration.Constants.autoIntegration',
    icon: getAssetURL(ADMIN_APP_ASSET_PATHS?.integration?.looxReviews),
    smallIcon: getAssetURL(ADMIN_APP_ASSET_PATHS?.integration?.small?.looxReviews),
    description: 'AdminHTML.Integration.Constants.productReview_LooxReviews_Description',
    appListingURL: 'https://loox.io/app/boostcommerce',
    instructionURL: 'https://support.boostcommerce.net/en/articles/9360332-loox-integration-guide',
    appType: AppType.reviews,
    appName: AppName.LOOX,
    render: (index, data) => {
      return <ReviewCard index={index} data={data} />;
    },
    position: 19
  },
  {
    name: 'AdminHTML.Integration.Constants.productReview_Okendo_Name',
    integration: 'AdminHTML.Integration.Constants.autoIntegration',
    icon: getAssetURL(ADMIN_APP_ASSET_PATHS?.integration?.okendo),
    smallIcon: getAssetURL(ADMIN_APP_ASSET_PATHS?.integration?.small?.okendo),
    description: 'AdminHTML.Integration.Constants.productReview_Okendo_Description',
    appListingURL: 'https://www.okendo.io/forms/demo/?affiliate_id=boostcommerce.net',
    instructionURL:
      'https://support.boostcommerce.net/en/articles/9360212-okendo-integration-guide',
    appType: AppType.reviews,
    appName: AppName.OKENDO,
    render: (index, data) => {
      return <ReviewCard index={index} data={data} />;
    },
    position: 20
  },
  {
    name: 'AdminHTML.Integration.Constants.productReview_LAIAliExpress_Name',
    integration: 'AdminHTML.Integration.Constants.autoIntegration',
    icon: getAssetURL(ADMIN_APP_ASSET_PATHS?.integration?.laiAliExpress),
    smallIcon: getAssetURL(ADMIN_APP_ASSET_PATHS?.integration?.small?.laiAliExpress),
    description: 'AdminHTML.Integration.Constants.productReview_LAIAliExpress_Description',
    appListingURL: 'https://partners.smartifyapps.com/apps/lai_reviews/boostcommerce',
    instructionURL:
      'https://support.boostcommerce.net/en/articles/9360204-lai-aliexpress-reviews-integration-guide',
    appType: AppType.reviews,
    appName: AppName.LAI_ALI_EXPRESS,
    render: (index, data) => {
      return <ReviewCard index={index} data={data} />;
    },
    position: 18
  },
  {
    name: 'AdminHTML.Integration.Constants.productReview_AliReview_Name',
    integration: 'AdminHTML.Integration.Constants.autoIntegration',
    icon: getAssetURL(ADMIN_APP_ASSET_PATHS?.integration?.aliReview),
    smallIcon: getAssetURL(ADMIN_APP_ASSET_PATHS?.integration?.small?.aliReview),
    description: 'AdminHTML.Integration.Constants.productReview_AliReview_Description',
    appListingURL: 'https://apps.shopify.com/ali-reviews',
    instructionURL: 'https://help.boostcommerce.net/article/418-ali-review',
    appType: AppType.reviews,
    appName: AppName.ALI_REVIEW,
    render: (index, data) => {
      const tenantId = getShop();
      if (!_.includes(aliReviewSupport, tenantId)) return null;
      return <AliCard index={index} data={data} />;
    },
    position: 8
  }
];

export const PAGE_BUILDERS = [
  {
    name: 'AdminHTML.Integration.Constants.pageBuilder_GemPages_Name',
    icon: getAssetURL(ADMIN_APP_ASSET_PATHS?.integration?.gempages),
    description: 'AdminHTML.Integration.Constants.pageBuilder_GemPages_Description',
    appListingURL: 'https://apps.shopify.com/gempages',
    instructionURL:
      'https://support.boostcommerce.net/en/articles/9359395-gempages-integration-guide',
    render: (index, data) => {
      return <GemPagesCard index={index} data={data} />;
    },
    appName: AppName.GEMPAGES,
    appType: AppType.pageBuilder,
    position: 14
  },
  {
    name: 'AdminHTML.Integration.Constants.pageBuilder_Shopney_Name',
    icon: getAssetURL(ADMIN_APP_ASSET_PATHS?.integration?.shopney),
    description: 'AdminHTML.Integration.Constants.pageBuilder_Shopney_Description',
    appListingURL: 'https://apps.shopify.com/shopney-mobile-app',
    instructionURL:
      'https://support.boostcommerce.net/en/articles/9360624-shopney-integration-guide',
    appName: AppName.SHOPNEY,
    appType: AppType.pageBuilder,
    position: 25
  },
  {
    name: 'AdminHTML.Integration.Constants.pageBuilder_Vajro_Name',
    icon: getAssetURL(ADMIN_APP_ASSET_PATHS?.integration?.vajro),
    description: 'AdminHTML.Integration.Constants.pageBuilder_Vajro_Description',
    appListingURL: 'https://apps.shopify.com/vajro?utm_source=from_bcm',
    instructionURL: 'https://support.boostcommerce.net/en/articles/9356300-vajro-integration-guide',
    appName: AppName.VAJRO,
    appType: AppType.pageBuilder,
    position: 28
  }
];

export const OTHERS = [
  /*
  {
    name: 'AdminHTML.Integration.Constants.others_QuickviewBySecomap_Name',
    integration: 'AdminHTML.Integration.Constants.autoIntegration',
    icon: getAssetURL(ADMIN_APP_ASSET_PATHS?.integration?.quickViewBySecomapp),
    description: 'AdminHTML.Integration.Constants.others_QuickviewBySecomap_Description',
    appListingURL: 'https://apps.shopify.com/quick-view',
    instructionURL:
      'https://support.boostcommerce.net/en/articles/9360724-quick-view-by-secomapp-integration-guide',
    integration: 'AdminHTML.Integration.Constants.autoIntegration',
    appType: AppType.others,
    appName: 'secomapp',
    render: (index, data) => {
      return <IntegrationCard index={index} data={data} />;
    }
  },
  {
    name: 'AdminHTML.Integration.Constants.others_ProductCompare_Name',
    icon: getAssetURL(ADMIN_APP_ASSET_PATHS?.integration?.productCompare),
    description: 'AdminHTML.Integration.Constants.others_ProductCompare_Description',
    appListingURL: 'https://apps.shopify.com/product-compare',
    instructionURL:
      'https://support.boostcommerce.net/en/articles/9356526-equate-product-compare-integration-guide'
  },
  {
    name: 'AdminHTML.Integration.Constants.others_DiscountNinja_Name',
    icon: getAssetURL(ADMIN_APP_ASSET_PATHS?.integration?.discountNinja),
    description: 'AdminHTML.Integration.Constants.others_DiscountNinja_Description',
    appListingURL: 'https://apps.shopify.com/discount-url',
    instructionURL:
      'https://support.boostcommerce.net/en/articles/9360736-discount-ninja-integration-guide'
  },
  {
    name: 'AdminHTML.Integration.Constants.productLabel_Fera_Name',
    integration: 'AdminHTML.Integration.Constants.autoIntegration',
    icon: getAssetURL(ADMIN_APP_ASSET_PATHS?.integration?.fera),
    description: 'AdminHTML.Integration.Constants.productLabel_Fera_Description',
    appListingURL: 'https://apps.shopify.com/fera',
    instructionURL:
      'https://support.boostcommerce.net/en/articles/9356337-fera-social-proof-integration-guide',
    integration: 'AdminHTML.Integration.Constants.autoIntegration',
    appType: AppType.others,
    appName: 'fera',
    render: (index, data) => {
      return <IntegrationCard index={index} data={data} />;
    }
  },
  */
  {
    name: 'AdminHTML.Integration.Constants.other_Shopify_Combined_Listings_Name',
    icon: getAssetURL(ADMIN_APP_ASSET_PATHS?.integration?.shopifyCombinedListings),
    description: 'AdminHTML.Integration.Constants.other_Shopify_Combined_Listings_Description',
    appListingURL: 'https://apps.shopify.com/helpdesk',
    instructionURL: 'https://support.boostcommerce.net/en/articles/14720893-shopify-combined-listings-integration-guide',
    render: (index, data) => {
      return <OtherCard rd index={index} data={data} />;
    },
    appName: AppName.SHOPIFY_COMBINED_LISTINGS,
    appType: AppType.others,
    tags: ['AdminHTML.Integration.Integration.beta']
  }
];

export const APPS_BANNERS = [
  {
    image: {
      source: getAssetURL(ADMIN_APP_ASSET_PATHS?.integration?.appBanner01)
    },
    name: 'appsBanners_Banner1',
    url: 'https://apps.shopify.com/growave?utm_source=partner&utm_medium=banner&utm_campaign=Boost'
  },
  {
    image: {
      source: getAssetURL(ADMIN_APP_ASSET_PATHS?.integration?.appBanner02)
    },
    name: 'appsBanners_Banner2',
    url: 'https://apps.shopify.com/split-partial-payments?utm_source=boostcommerce'
  }
];

export const SMS_EMAIL = [
  {
    name: 'AdminHTML.Integration.Constants.smsEmail_Klaviyo_Name',
    icon: getAssetURL(ADMIN_APP_ASSET_PATHS?.integration?.klaviyo),
    description: 'AdminHTML.Integration.Constants.smsEmail_Klaviyo_Description',
    appListingURL: 'https://apps.shopify.com/klaviyo-email-marketing',
    instructionURL:
      'https://support.boostcommerce.net/en/articles/9710489-klaviyo-email-marketing-sms',
    render: (index, data) => {
      return <KlaviyoCard index={index} data={data} />;
    },
    appType: AppType.smsEmail,
    appName: AppName.KLAVIYO,
    isFeaturingPartner: true
  },
  {
    name: 'AdminHTML.Integration.Constants.smsEmail_Attentive_Name',
    icon: getAssetURL(ADMIN_APP_ASSET_PATHS?.integration?.attentive),
    description: 'AdminHTML.Integration.Constants.smsEmail_Attentive_Description',
    appListingURL: 'https://apps.shopify.com/attentive',
    instructionURL:
      'https://support.boostcommerce.net/en/articles/12379704-attentive-integration-guide',
    render: (index, data) => {
      return <AttentiveCard index={index} data={data} />;
    },
    appType: AppType.smsEmail,
    appName: AppName.ATTENTIVE,
    position: 9
  }
];

export const GLOBAL_SELLING_INTEGRATIONS = [
  {
    name: 'AdminHTML.Integration.Constants.globalSelling_GlobalE_Name',
    icon: getAssetURL(ADMIN_APP_ASSET_PATHS?.integration?.globalE),
    description: 'AdminHTML.Integration.Constants.globalSelling_GlobalE_Description',
    appListingURL: 'https://www.global-e.com/',
    instructionURL:
      'https://support.boostcommerce.net/en/articles/10353291-global-selling-for-shopify-markets#h_f66d342387',
    appName: AppName.GLOBAL_E,
    appType: AppType.globalSelling,
    render: (index, data) => {
      return <GlobalSellingCard index={index} data={data} />;
    }
  }
];

export const SUPPORT_CRM = [
  {
    name: 'AdminHTML.Integration.Constants.supportCRM_Gorgias_Name',
    icon: getAssetURL(ADMIN_APP_ASSET_PATHS?.integration?.gorgias),
    description: 'AdminHTML.Integration.Constants.supportCRM_Gorgias_Description',
    appListingURL: 'https://apps.shopify.com/helpdesk',
    instructionURL: 'https://support.boostcommerce.net/en/articles/14482215-gorgias-integration-guide',
    render: (index, data) => {
      return <SupportCRMCard index={index} data={data} />;
    },
    appName: AppName.GORGIAS,
    appType: AppType.supportCRM,
  }
];

export const ANALYTICS = [
  {
    name: 'AdminHTML.Integration.Constants.analytics_GA4_Name',
    icon: getAssetURL(ADMIN_APP_ASSET_PATHS?.integration?.googleAnalytics4),
    description: 'AdminHTML.Integration.Constants.analytics_GA4_Description',
    appListingURL: 'https://apps.shopify.com/google-analytics-4',
    instructionURL: 'https://support.boostcommerce.net/en/articles/15706487-google-analytics-4-ga4-integration-guide',
    render: (index, data) => {
      return <AnalyticsCard index={index} data={data} />;
    },
    appName: AppName.GOOGLE_ANALYTICS_4,
    appType: AppType.analytics,
  }
];



export const initIntegrationStructure = list => {
  const cloned = _.cloneDeep(list);

  let table = [];
  _.forEach(cloned, value => {
    if (table.length === 0 || table[table.length - 1].length === 3) table.push([]);
    table[table.length - 1].push(value);
  });
  cloned.length = 0;
  cloned.push.apply(cloned, table);

  return cloned;
};

export const ALL_APP = [
  ...MULTI_LANGUAGE.flat(1),
  ...MULTI_CURRENCY.flat(1),
  ...WISHLIST.flat(1),
  ...PRODUCT_LABELS.flat(1),
  ...PRODUCT_REVIEWS.flat(1),
  ...OTHERS.flat(1),
  ...GLOBAL_SELLING_INTEGRATIONS.flat(1),
  ...SUPPORT_CRM.flat(1)
];

export const REACT_DOM_SCRIPT =
  'https://unpkg.com/react-dom@18.2.0/umd/react-dom.production.min.js';
export const REACT_SCRIPT = 'https://unpkg.com/react@18.2.0/umd/react.production.min.js';

export const FILTER_INTEGRATION_TYPE = [
  {
    label: 'AdminHTML.Integration.Integration.featuringPartner',
    value: AppType.featuringPartner
  },
  {
    label: 'AdminHTML.Integration.Integration.smsEmail',
    value: AppType.smsEmail
  },
  {
    label: 'AdminHTML.Integration.Integration.productReviewsTab',
    value: AppType.reviews
  },
  {
    label: 'AdminHTML.Integration.Integration.wishlistTab',
    value: AppType.wishlists
  },
  {
    label: 'AdminHTML.Integration.Integration.multipleLanguageTab',
    value: AppType.languages
  },
  {
    label: 'AdminHTML.Integration.Integration.productLabelsTab',
    value: AppType.labels
  },
  {
    label: 'AdminHTML.Integration.Integration.multipleCurrencyTab',
    value: AppType.currencies
  },
  {
    label: 'AdminHTML.Integration.Integration.pageBuilderTab',
    value: AppType.pageBuilder
  },
  {
    label: 'AdminHTML.Integration.Integration.globalSellingTab',
    value: AppType.globalSelling
  },
  {
    label: 'AdminHTML.Integration.Integration.supportCRMTab',
    value: AppType.supportCRM
  },
  {
    label: 'AdminHTML.Integration.Integration.othersTab',
    value: AppType.others
  },
  {
    label: 'AdminHTML.Integration.Integration.analyticsTab',
    value: AppType.analytics
  }
]